(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["TOP"]) return;
  try {
    
  
$(function() {
	$(window).scroll(function () {
		var top = $(this).scrollTop();
		if(top > 150) {
			$("logotop img").fadeIn('800');
		}else {
			$("logotop img").fadeOut('800');
		}
	});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.headerWrapper = this;
      this.overlayCheckScheduled = false;
      this.boundHandleOverlayCheck = this.handleOverlayCheck.bind(this);

      this.createObserver();

      this.updateHeaderOverlayState();
      window.addEventListener('scroll', this.boundHandleOverlayCheck, { passive: true });
      window.addEventListener('resize', this.boundHandleOverlayCheck);
      window.addEventListener('load', this.boundHandleOverlayCheck);
      document.addEventListener('shopify:section:load', this.boundHandleOverlayCheck);
      document.addEventListener('shopify:section:reorder', this.boundHandleOverlayCheck);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.boundHandleOverlayCheck) {
        window.removeEventListener('scroll', this.boundHandleOverlayCheck);
        window.removeEventListener('resize', this.boundHandleOverlayCheck);
        window.removeEventListener('load', this.boundHandleOverlayCheck);
        document.removeEventListener('shopify:section:load', this.boundHandleOverlayCheck);
        document.removeEventListener('shopify:section:reorder', this.boundHandleOverlayCheck);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    handleOverlayCheck() {
      if (this.overlayCheckScheduled) return;

      this.overlayCheckScheduled = true;
      requestAnimationFrame(() => {
        this.overlayCheckScheduled = false;
        this.updateHeaderOverlayState();
      });
    }

    updateHeaderOverlayState() {
      if (!this.headerWrapper || typeof document.elementsFromPoint !== 'function') {
        return;
      }

      const rect = this.headerWrapper.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        return;
      }

      const viewportWidth = Math.max(window.innerWidth, 1);
      const viewportHeight = Math.max(window.innerHeight, 1);

      if (rect.bottom <= 0 || rect.top >= viewportHeight) {
        return;
      }

      const sampleX = rect.left + rect.width / 2;
      const sampleY = rect.top + rect.height / 2;
      const clampedX = Math.min(Math.max(sampleX, 0), viewportWidth - 1);
      const clampedY = Math.min(Math.max(sampleY, 0), viewportHeight - 1);

      const elements = document.elementsFromPoint(clampedX, clampedY);
      let overlayingImage = false;

      for (const element of elements) {
        if (!element || this.contains(element)) {
          continue;
        }

        if (element.dataset && element.dataset.headerOverlay === 'true') {
          overlayingImage = true;
          break;
        }

        const tagName = element.tagName ? element.tagName.toLowerCase() : '';
        if (tagName === 'img' || tagName === 'picture' || tagName === 'video' || tagName === 'canvas') {
          overlayingImage = true;
          break;
        }

        const style = window.getComputedStyle(element);
        if (!style) {
          continue;
        }

        const backgroundImage = style.backgroundImage;
        if (backgroundImage && backgroundImage !== 'none' && backgroundImage.includes('url(')) {
          overlayingImage = true;
          break;
        }
      }

      this.headerWrapper.classList.toggle('header-wrapper--transparent', overlayingImage);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origin-kv-01"] && !Shopify.designMode) return;
  try {
    
  const targets = document.querySelectorAll('.origin-kv-01 .anileft');

  function checkVisibility() {
    const windowHeight = window.innerHeight;

    for (let i = 0; i < targets.length; i++) {
      const rect = targets[i].getBoundingClientRect().top;
      const scroll = window.pageYOffset || document.documentElement.scrollTop;
      const offset = rect + scroll;

      if (scroll > offset - windowHeight + 10) {
        targets[i].classList.add('__shutter');
        const imgWrap = targets[i].querySelector('img');
        imgWrap.style.animation = 'ani_fadein 0.5s ease-out 0.7s 1 forwards';
      } else {
        targets[i].classList.remove('__shutter');
        const imgWrap = targets[i].querySelector('img');
        imgWrap.style.animation = '';
      }
    }
  }

  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', checkVisibility);
  window.addEventListener('DOMContentLoaded', checkVisibility);


  } catch(e) { console.error(e); }
})();
})();
